export function getList(list) {
  return list.map(item => ({
    id: item.location._id,
    text: item.location.name,
  }))
}
